<!--单位信息模块-->
<template>
  <div class="dayInfoBody usePowerUnitDiv">
    <div class="topLeftTitleContent">负荷设备信息</div>
    <div class="dayInfoContent bodyBorder">
      <div class="divbody">
        <div class="column">
          <div class="usePowerUnitBlock">
            <p class="usePowerUnitBoxTitle">配电房数量</p>
            <p class="usePowerUnitBoxInfo">1</p>
          </div>
          <div class="usePowerUnitBlock" style="margin-bottom: 20%;">
            <p class="usePowerUnitBoxTitle" style="height: 40px;line-height: 40px;font-size: 14px;">负荷容量(kVA)</p>
            <p class="usePowerUnitBoxInfo special" style="height: 50px;line-height: 50px;">3000</p>
          </div>
        </div>
        <div class="column">
          <div class="usePowerUnitBlock">
            <p class="usePowerUnitBoxTitle">负荷设备数</p>
            <p class="usePowerUnitBoxInfo">2</p>
          </div>
          <canvasCircle class="circle" color="#86e4f5" backgroundColor="#395667" :pvalue="917.84" pcontent="实时负荷(kW)"
            rate="30.59"></canvasCircle>
        </div>
        <div class="column">
          <div class="usePowerUnitBlock">
            <p class="usePowerUnitBoxTitle">日最大需量(kW)</p>
            <p class="usePowerUnitBoxInfo">75675.2</p>
          </div>
          <canvasCircle class="circle" color="#ff7656" backgroundColor="#395667" pvalue="404.67" pcontent="日最大负荷(kW)"
            rate="12.49"></canvasCircle>
        </div>
        <div class="column">
          <div class="usePowerUnitBlock">
            <p class="usePowerUnitBoxTitle">月最大需量(kW)</p>
            <p class="usePowerUnitBoxInfo">10234</p>
          </div>
          <canvasCircle class="circle" color="#ff9900" backgroundColor="#395667" pvalue="404.67" pcontent="月最大负荷(kW)"
            rate="13.49"></canvasCircle>
        </div>
      </div>
      <div class="divbody">
        <vchart ref='vchartLine'></vchart>
      </div>
    </div>
  </div>
</template>

<script>
  import canvasCircle from '@/page/unitKanBan/component/canvasCircle.vue'
  import vchart from '@/components/module/chart/vchart.vue'
  import {findDemand} from "../../../api/abbNewApi"
  export default {
    components: {
      canvasCircle,
      vchart,
    },
    props: [],
    data () {
      return {
        dayMaxNeed: 0,
        newdayMaxNeed: 0,

        monthMaxNeed: 0,
        newmonthMaxNeed: 0,
        dayMaxLoad: 0,
        monthMaxLoad: 0,
        todayLoadLine: [],
        nowLoadDeviceFromname: "",
        loadDeviceList: [],
        deviceNoToArchivesInfo: {},
        lineOption: {
          xAxis: {
            type: 'category',
          },
          yAxis: {
            type: 'value'
          },
          series: []
        },
      }
    },
    created () {},
    mounted () {
      var nv={"xAxis": {"type": "category","splitLine": {"lineStyle": {"type": "dashed","color": "#6f7284"}},"axisLabel": {"interval": 23,"textStyle": {"color": "#ffffff"}},"data": ["00:00","00:05","00:10","00:15","00:20","00:25","00:30","00:35","00:40","00:45","00:50","00:55","01:00","01:05","01:10","01:15","01:20","01:25","01:30","01:35","01:40","01:45","01:50","01:55","02:00","02:05","02:10","02:15","02:20","02:25","02:30","02:35","02:40","02:45","02:50","02:55","03:00","03:05","03:10","03:15","03:20","03:25","03:30","03:35","03:40","03:45","03:50","03:55","04:00","04:05","04:10","04:15","04:20","04:25","04:30","04:35","04:40","04:45","04:50","04:55","05:00","05:05","05:10","05:15","05:20","05:25","05:30","05:35","05:40","05:45","05:50","05:55","06:00","06:05","06:10","06:15","06:20","06:25","06:30","06:35","06:40","06:45","06:50","06:55","07:00","07:05","07:10","07:15","07:20","07:25","07:30","07:35","07:40","07:45","07:50","07:55","08:00","08:05","08:10","08:15","08:20","08:25","08:30","08:35","08:40","08:45","08:50","08:55","09:00","09:05","09:10","09:15","09:20","09:25","09:30","09:35","09:40","09:45","09:50","09:55","10:00","10:05","10:10","10:15","10:20","10:25","10:30","10:35","10:40","10:45","10:50","10:55","11:00","11:05","11:10","11:15","11:20","11:25","11:30","11:35","11:40","11:45","11:50","11:55","12:00","12:05","12:10","12:15","12:20","12:25","12:30","12:35","12:40","12:45","12:50","12:55","13:00","13:05","13:10","13:15","13:20","13:25","13:30","13:35","13:40","13:45","13:50","13:55","14:00","14:05","14:10","14:15","14:20","14:25","14:30","14:35","14:40","14:45","14:50","14:55","15:00","15:05","15:10","15:15","15:20","15:25","15:30","15:35","15:40","15:45","15:50","15:55","16:00","16:05","16:10","16:15","16:20","16:25","16:30","16:35","16:40","16:45","16:50","16:55","17:00","17:05","17:10","17:15","17:20","17:25","17:30","17:35","17:40","17:45","17:50","17:55","18:00","18:05","18:10","18:15","18:20","18:25","18:30","18:35","18:40","18:45","18:50","18:55","19:00","19:05","19:10","19:15","19:20","19:25","19:30","19:35","19:40","19:45","19:50","19:55","20:00","20:05","20:10","20:15","20:20","20:25","20:30","20:35","20:40","20:45","20:50","20:55","21:00","21:05","21:10","21:15","21:20","21:25","21:30","21:35","21:40","21:45","21:50","21:55","22:00","22:05","22:10","22:15","22:20","22:25","22:30","22:35","22:40","22:45","22:50","22:55","23:00","23:05","23:10","23:15","23:20","23:25","23:30","23:35","23:40","23:45","23:50","23:55"]},"yAxis": {"type": "value","name": "","splitLine": {"lineStyle": {"type": "dashed","color": "#6f7284"}},"axisLabel": {"textStyle": {"color": "#ffffff"}}},"legend": {"data": ["昨日负荷","前日负荷","今日负荷"],"x": "right","y": "top","padding": [10,40,0,0],"orient": "horizontal"},"tooltip": {"trigger": "axis","axisPointer": {"label": {"backgroundColor": "#6a7985"}}},"backgroundColor": "","grid": {"height": "80%","left": "8%","right": "5%","bottom": "3%","containLabel": true},"series": [{"data": ["404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67",null,"404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67"],"type": "line","color": "#8515c1","areaStyle": {"color": "#0f2e5b"},"markPoint": {"data": [{"name": "最大值","type": "max"}]},"name": "前日负荷"},{"data": ["404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67"],"type": "line","color": "#ff9900","areaStyle": {"color": "#0f2e5b"},"markPoint": {"data": [{"name": "最大值","type": "max"}]},"name": "昨日负荷"},{"data": ["404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67","404.67",null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],"type": "line","color": "#0e96f6","areaStyle": {"color": "#2e5897"},"markPoint": {"data": [{"name": "最大值","type": "max"}]},"name": "今日负荷"}]}
      this.$refs.vchartLine.setData(nv)

    },
    destroyed () {
      this.realTimeValueStore.commit("removeKeys",this.nowLoadDeviceFromname)
      removeTask("refreshUnitDayInfo")
    },
    computed: {
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },

      nowUnit () {
        var nowunit=this.$store.unitStore.getters.getNowUnit
        findDemand({'unitId': nowunit.id}).then(res => {
          this.newdayMaxNeed=res.data.nowDayDemand
          this.newmonthMaxNeed=res.data.nowMonthDemand
          if(res.code!=200) {
            this.findDemand_fn()
          }
        })
        return nowunit
      },
      loadCapacity () {
        //总负荷容量,负荷设备是负荷配置中配置的当前单位的负荷设备，然后通过他们绑定的台账来查询额定容量属性
        var count=0
        for(var i=0,len=this.loadDeviceList.length;i<len;i++) {
          var item=this.loadDeviceList[i]
          var info=this.deviceNoToArchivesInfo[item.deviceno]
          if(!isempty(info)&&!isempty(info.next)) {
            var target=info.next.find(it => it.propertyCode=="Capacity")
            let target2=info.next.find(it => it.propertyCode=="edrl")
            if(!isempty(target)&&!isempty(target.value)) {
              try {
                count+=parseFloat(target.value)
              } catch(e) {}
            }
            if(!isempty(target2)&&!isempty(target2.value)) {
              try {
                count+=parseFloat(target2.value)
              } catch(e) {}
            }
          }
        }
        return parseInt(count)
      },
      nowReadDeviceTree () {
        //当前单位可查看虚拟设备树
        return this.$store.deviceStore.getters.getReadDeviceTreeByUnitId(this.nowUnit.id)
      },
      roomCount () {
        //配电房数量，由当前单位下所有类型为配电房的虚拟设备组的数量决定，配电房下的配电房也算配电房
        var list=treeToList(this.nowReadDeviceTree,'next',item => {
          return item.hasOwnProperty("next")
        })
        return list.filter(item => {
          return item.devicetype==2
        }).length
      },
      realLoad () {
        var list=this.nowLoadDeviceFromname
        var values=this.realTimeValueStore.getters.getValue(list)
        var count=0
        for(var i=0,len=values.length;i<len;i++) {
          if(values[i]!=undefined) {
            count+=parseFloat(values[i])
          }
        }
        //实时负荷
        return (Math.round(count*Math.pow(10,2)))/Math.pow(10,2)
      },
      realLoadRate () {
        if(this.loadCapacity!=0&&this.realLoad!=0) {
          return cutDigital(this.realLoad/this.loadCapacity*100)
        }
        return '0.00'
      },
      dayMaxRate () {
        var rate='0.00'
        try {
          rate=cutDigital(this.dayMaxLoad/this.loadCapacity*100)
          if(isempty(rate)||isNaN(rate)) {
            return '0.00'
          }
        } catch(e) {}
        return rate
      },

      xList () {
        var list=[]
        for(var h=0,len=24;h<len;h++) {
          for(var m=0,lenm=60;m<lenm;m+=5) {
            list.push((h<10? '0':'')+h+':'+(m<10? '0':'')+m)
          }
        }
        return list
      },
      getLine () {
        return {
          xAxis: {
            type: 'category',
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#6f7284'
              }
            },
            axisLabel: {
              interval: 23,
              textStyle: {
                color: '#ffffff',
              }

            },
            data: this.xList,
          },
          yAxis: {
            type: 'value',
            name: '',
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#6f7284'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#ffffff',
              },
            },

          },
          legend: {
            data: ['昨日负荷','前日负荷','今日负荷'],
            x: 'right',
            y: 'top',
            padding: [10,40,0,0],
            orient: "horizontal",
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          backgroundColor: '',
          grid: {
            height: '80%',
            left: '8%',
            right: '5%',
            bottom: '3%',
            containLabel: true
          },
          series: this.todayLoadLine
        }
      },
    },
    watch: {

      nowLoadDeviceFromname (nv,ov) {
        if(!isempty(ov)) {
          //移除旧变量
          this.realTimeValueStore.commit("removeKeys",ov)
        }
        if(!isempty(nv)) {
          this.realTimeValueStore.commit("addKeys",nv)
        }
      },
      nowUnit (nv,ov) {
        this.getLoadValue(nv.id)
        this.findDemand_fn()
      },
    },
    methods: {
      findDemand_fn () {
        findDemand({'unitId': this.nowUnit.id}).then(res => {
          this.newdayMaxNeed=res.data.nowDayDemand
          this.newmonthMaxNeed=res.data.nowMonthDemand
          if(res.code!=200) {
            this.findDemand_fn()
          }
        })
      },
      getLoadValue (unitId) {
        //获取单位相关的数据
        if(isempty(unitId)) {
          return
        }
        //获取变压器负荷设备列表
        this.$api.deviceApi.getDeviceListByDeviceType(unitId,'load',respon => {
          this.loadDeviceList=respon
          this.$api.archivesApi.getArchivesInfoByVirtualDeviceNos(respon.map(item => item.deviceno).join(','),tree => {
            this.deviceNoToArchivesInfo=tree
          })
        })
        //查询月最大需量
        this.$api.powerApi.getMonthMaxLoadDemand(unitId,new Date().getTime(),respon => {
          this.monthMaxNeed=isempty(respon)? '--':respon
        })
        //查询日最大需量
        this.$api.powerApi.getDayMaxLoadDemand(unitId,new Date().getTime(),respon => {
          this.dayMaxNeed=isempty(respon)? '--':respon
        })
        //查询日最大负荷
        this.$api.powerApi.getDayMaxLoad(unitId,new Date().getTime(),respon => {
          this.dayMaxLoad=isempty(respon)? '--':respon
        })
        //查询月最大负荷
        this.$api.powerApi.getMonthMaxLoad(unitId,new Date().getTime(),respon => {
          this.monthMaxLoad=isempty(respon)? '--':respon
        })
        //获取实时负荷
        this.$api.powerApi.getLoadFromnameByUnitId(unitId,respon => {
          this.nowLoadDeviceFromname=isempty(respon)? '--':respon
        })
        //获取当日负荷曲线
        var ser=[]
        this.$api.powerApi.getUnitDayLoadValues(unitId,new Date(getDay(-2)+' 00:00:00').getTime(),respon => {
          ser.push({
            data: respon,
            type: 'line',
            color: '#8515c1',
            areaStyle: {
              color: '#2e5897',
            },
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            name: '前日负荷'
          })
        })
        this.$api.powerApi.getUnitDayLoadValues(unitId,new Date(getDay(-1)+' 00:00:00').getTime(),respon => {
          ser.push({
            data: respon,
            type: 'line',
            color: '#ff9900',
            areaStyle: {
              color: '#2e5897',
            },
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            name: '昨日负荷'
          })
        })
        this.$api.powerApi.getUnitDayLoadValues(unitId,new Date(getDay(0)+' 00:00:00').getTime(),respon => {
          ser.push({
            data: respon,
            type: 'line',
            color: '#0e96f6',
            areaStyle: {
              color: '#2e5897',
            },
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            name: '今日负荷'
          })
        })
        this.todayLoadLine=ser
      },
    }
  }
</script>

<style scoped>
  @import url("../../../components/css/usePowerUnit.css");

  .divbody>>>.default-chart {
    height: 100%;
    width: 100%;
  }

  .dayInfoBody {
    height: 240px;
  }

  .dayInfoContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: calc(100% - 31px);
  }

  .divbody {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 48.5%;
    height: calc(100% - 20px);
  }

  .column {
    width: 23.5%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .info {
    font-size: 16px;
    font-family: "黑体";
  }

  .circle {
    width: 100%;
  }

  @media screen and (max-width: 1200px) {
    .dayInfoContent {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
    }

    .divbody {
      width: 100%;
      height: 250px;
    }
  }
</style>